module.exports = __webpack_public_path__ + "static/img/11.5147360.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/11.png
// module id = m4yg
// module chunks = 0